export default __webpack_public_path__ + "static/media/devprime-frontend.de720c37.png";